export const parseValidationErrors = (errorResponse) => {
  const result = {
    fieldErrors: {},
    generalErrors: [],
  };

  if (!errorResponse || !Array.isArray(errorResponse.errors)) {
    if (errorResponse?.message) {
      result.generalErrors.push(errorResponse.message);
    }
    return result;
  }

  errorResponse.errors.forEach((error) => {
    if (!error.msg) {
      return;
    }

    const hasPath = error.path && error.path.trim() !== '';
    const hasAffectedFields =
      error.affected_fields &&
      Array.isArray(error.affected_fields) &&
      error.affected_fields.length > 0;

    if (hasPath) {
      if (!result.fieldErrors[error.path]) {
        result.fieldErrors[error.path] = error.msg;
      }
    }

    if (hasAffectedFields) {
      error.affected_fields.forEach((fieldName) => {
        if (!result.fieldErrors[fieldName]) {
          result.fieldErrors[fieldName] = error.msg;
        }
      });
    }

    if (!hasPath && !hasAffectedFields) {
      result.generalErrors.push(error.msg);
    }
  });

  return result;
};

const API_FIELD_TO_FORM_FIELD = {
  client_transaction_id: 'clientTransactionId',
  refund_to_address_line1: 'refundToAddressLine1',
  refund_to_address_line2: 'refundToAddressLine2',
  refund_to_city: 'city',
  refund_to_state: 'state',
  refund_to_zip: 'refundToZip',
  refund_to_country: 'refundToCountry',
  general_ledger: 'generalLedger',
  vendor_id_number: 'vendorIdNumber',
  payee_account_number: 'payeeAccountNumber',
  business_unit_id: 'businessUnitId',
  client_bank_account_id: 'clientBankAccountId',
  custom_payment_type_id: 'customPaymentTypeId',
  entity_type: 'entityType',
  line_items: 'lineItems',
};

const toFormFieldName = (fieldName) => {
  if (!fieldName) return fieldName;
  return API_FIELD_TO_FORM_FIELD[fieldName] || fieldName;
};

const appendFieldError = (fieldErrors, fieldName, message) => {
  if (!fieldName || !message) return;

  const formFieldName = toFormFieldName(fieldName);
  if (!fieldErrors[formFieldName]) {
    fieldErrors[formFieldName] = { messages: [] };
  }
  fieldErrors[formFieldName].messages.push(message);
};

export const normalizeFieldErrors = (errorResponse) => {
  const errors = errorResponse?.errors;

  if (!errors) {
    return {};
  }

  if (!Array.isArray(errors) && typeof errors === 'object') {
    return errors;
  }

  if (!Array.isArray(errors)) {
    return {};
  }

  const fieldErrors = {};

  // INFO: Supports standard error arrays after legacy field-error objects are
  // returned above.
  errors.forEach((error) => {
    appendFieldError(fieldErrors, error.path, error.msg || error.message);

    if (Array.isArray(error.affected_fields)) {
      error.affected_fields.forEach((fieldName) => {
        appendFieldError(fieldErrors, fieldName, error.msg || error.message);
      });
    }
  });

  return fieldErrors;
};

export const isValidationError = (errorResponse) => {
  return (
    errorResponse &&
    (errorResponse.error_code === 'VALIDATION_FAILED' ||
      Array.isArray(errorResponse.errors))
  );
};

export const getGeneralErrorMessage = (errorResponse, defaultMessage) => {
  if (!errorResponse) {
    return defaultMessage;
  }

  return (
    errorResponse.message ||
    errorResponse.msg ||
    errorResponse.error ||
    defaultMessage
  );
};
